module.exports = __webpack_public_path__ + "img/menu-movil-icon-close.77182588.svg";